import {makeAutoObservable, reaction} from "mobx";

export class BooleanObservable {
  value: boolean;
  isDirty: boolean;
  validate?: (toValidate: boolean) => boolean;

  constructor(value: boolean, validate?: (toValidate: boolean) => boolean) {
    makeAutoObservable(this);
    this.value = value;
    this.isDirty = false;
    this.validate = validate;
    reaction(
      () => this.value,
      () => this.setIsDirty(true)
    );
  }

  setIsDirty = (value: boolean) => {
    this.isDirty = value;
  };

  setBoolean = (value: boolean) => {
    this.value = value;
  };

  get isValid() {
    return (
      this.validate == null || !this.isDirty || this.validate?.(this.value)
    );
  }
}
